module.exports = {
  hd: {
    login: '登錄',
    register: '註冊',
    announcement: '公告',
    game: '遊戲',
    otc: '法幣交易',
    capital: '資產',
    transaction: '場外交易',
    currency: '幣幣交易',
    currencyMall: '交易中心',
    co: '合約交易',
    coCenter: '合約大廳',
    home: '首頁',
    userCenter: '個人中心',
    orderManage: '訂單',
    apiManage: '我的API',
    ask: '發起提問',
    logout: '退出',
    chaindown: '商務合作',
    economic: '經濟人管理',
    adcenter_def: '普通交易',
    adcenter_big: '大宗交易',
    mining: '挖礦交易',
    invitation: '邀請分紅',
    msgcenter: '消息中心',
    set: '設置',
    otc_trade: "OTC交易",
    c2c_trade: "C2C交易"
  },
  // 底部
  ft: {
    tickets: "提交工單",
    partners: "合作夥伴",
    weibo: "官方微博",
    qqgroup: "官方QQ群",
    telegram: "官方電報群",
    email: "官方郵箱",
    facebook: "官方臉書",
    whitepapers: "官方白皮書",
  },
  main: {
    description: "描述",
    fbdw: '法幣計價單位',
    marketSet: '自選',
    allMarkets: "全部行情",
    more: '更多',
    search: '搜索',
    market: '市場',
    close: '最新價',
    rose: '漲跌',
    height: '最高價',
    low: '最低價',
    vol: '成交量',
    amount: '成交金額',
    no_data: '暫無市場信息',
    prompt: '溫馨提示：數字資產是創新的投資產品，價格波動較大，具有較高的投資風險，請您投資前對數字資產充分認知，理性判斷自己的投資能力，審慎做出投資決策',
    notice: '重要公告',
    deal_forehead: '成交額',
    loading_ing: '正在加載',
    theme: '主題',
    copy: "復製",
    blueTheme: '藍色版',
    whiteTheme: '淺色版',
    blackTheme: '黑色版',
    exchangeApp: "交易所APP",
    exchangeAppIntroduce: "快速便捷的全網交易平臺",
    bipayApp: "幣付寶APP",
    bipayAppIntroduce: "支付、遊戲、應用等一體化錢包",
    app_ios: "IOS企業版下載",
    app_ios_01: "請再次點擊我去信任並安裝",
    app_android: "Android版下載",
    app_h5: "免APP下載",
    app_download: 'APP下載',
    sweep_download: '掃碼下載',
    download_address: "下載地址",
    download_page: "下載頁面",
    app_01: "快速、便捷、安全的交易平臺",
    copySuccess: "復製成功",
    getCode: "獲取驗證碼",
    confirm: "確定",
    cancel: "取消",
    noData: "暫無數據",
    viewMore: "查看更多",
    ReleaseTime: "發布時間",
    notNull: "參數不能為空",
    sureDel: "你確定刪除嗎？",
    close_01: "關閉",
    NotOpen: "暫未開放",
    pleaseLogin: "請先登錄",
    serverException: "服務器異常",
    unknown: "未知",
    alert_01: "點擊右上角的",
    alert_02: "按鈕",
    alert_03: "選擇",
    alert_04: "在Safari中打開",
    alert_05: "在瀏覽器中打開",
    optional: "選填"
  },
  user: {
    announcement: '公告',
    userCenter: '用戶中心',
    langSetting: '語言設置',
    securityCenter: '安全中心',
    versionUpdates: '版本更新',
    monetaryUnitSetting: '貨幣單位設置',
    currencySet: '幣種設置',
    aboutUs: '關於我們',
    share: '分享我們',
    loginRegister: '登錄/註冊',
    logout: '註銷登入',
    money: "我的資金",
    deal: "我的交易",
    myOrder: "我的掛單",
    dealHistory: "成交記錄",
    lock: "鎖倉管理",
    lockHistory: "鎖倉記錄",
    releaseHistory: "釋放記錄",
    financial: "財務記錄",
    certification: "實名認證",
    security: "安全中心",
    recommended: "推薦計劃",
    workorder: "工單管理",
    bankcard: "支付綁定",
    personal: '個人信息',
  },
  // 首頁
  home: {
    next: '創業區',
    favorites: "自選區",
    markets: "交易區",
    performer: '漲幅榜',
    DropList: '跌幅榜',
    transferAccounts: '轉賬',
    ExpertsToShare: '專家分享',
    service: '客服',
    share: '分享',
    SaveMoneyLive: "存幣生息",
    CurrencyTraders: '幣商',
    experienceImmediately: '立即體驗',
    shares: '登陸後才可以分享哦',
    copysuc: '分享鏈接復製成功',
    nonsupport: '該瀏覽器不支持自動復製',
    classify: "分類",
    text_01: "開啟之後可以選擇幣種分類,關閉即可恢復默認列表",

  },
  // 交易中心
  trade: {
    latestPrice: '最新價',
    highestPrice: '最高價',
    minimumPrice: '最低價',
    applies: '漲跌幅',
    H_volume: '24H量',
    H_turnover: '24H額',
    K_line: 'K線圖',
    depth_line: '深度圖',
    LoginAccount: '登錄賬戶',
    liquidity: '讓資產流動起來',
    totalAssets: '凈資產折合',
    marketSet: '自選',
    searchSymbols: '查找幣種',
    symbols: '幣種',
    noSymbols: '暫無貨幣',
    latestDeal: '最新成交',
    coin: "幣種",
    time: '時間',
    price: '價格',
    amount: '數量',
    money_01: "資金",
    dealVolume: '成交量',
    dealAmount: '成交額',
    action: "操作",
    maker: "掛單",
    taker: "吃單",
    type: "類型",
    buy: '買入',
    sell: '賣出',
    buy_d: '買',
    sell_d: '賣',
    available: '可用',
    marketPrice: '市價',
    limitPrice: '限價',
    mergeDepth: '合並深度',
    total: '累計',
    dealDepth: '買賣深度',
    buyDepth: '買盤深度',
    sellDepth: '賣盤深度',
    entrustTime: '時間',
    entrustType: '類別',
    entrustPrice: '價格',
    entrustNumber: '數量',
    entrustMoney: '總額',
    dealMoney: '交易額',
    averagePrice: '平均成交價',
    notDeal: '尚未成交',
    orderSource: '訂單來源',
    status_c: '狀態/操作',
    cancelOrder: '撤單',
    notData: '暫無數據',
    confirmCancelText: '您確定要撤銷訂單嗎？',
    trade_01: "交易對，掛錯價格，成功後將無法取消。",
    trade_02: "警告：當前為",
    order: "訂單",
    cancel: '取消',
    confirm: '確定',
    myOrder: '我的掛單',
    myDeal: "我的成交",
    allOrder: '全部委托',
    dealHistory: '成交歷史',
    c_success: '操作成功',
    mPriceBuy: '以市場上最優價格買入',
    mPriceSell: '以市場上最優價格賣出',
    money: '金額',
    buyPrice: '買入價格',
    buyNumber: '買入數量',
    buyMoney: '買入金額',
    sellPrice: '賣出價格',
    sellNumber: '賣出數量',
    sellMoney: '賣出金額',
    fillError: '輸入錯誤',
    dealFw: '交易額超出可用範圍',
    dealCussess: '下單成功',
    dealId: '成交單號',
    dealTime: '成交時間',
    dealMoneys: '成交金額',
    dealPrice: '成交價格',
    serviceCharge: '手續費',
    tradeFee: "Trade Fee",
    errorInfor_1: '請先登錄賬號',
    errorInfor_2: '請先輸入價格',
    errorInfor_3: '沒有可用的',
    errorInfor_4: '請充值',
    selectPair: "選擇交易對",
    gains: "漲幅",
    drop: "跌幅",
    text_01: "成交才收，撤單退回。以實際成交的扣除為準",
    text_02: "你確定取消嗎？",
    text_03: "不能小於0",
    cancelSuccess: "取消成功",
    cannotBeZero: "不能為0",

  },
  // 行情
  market: {
    main: "主板",
    next: "創業板",
    currency: '幣種',
    price: '價格',
    increase: '漲幅',
    market: '行情',
    optionalArea: '自選區',
    loadingLoad: '加載中',
    noData: '暫無數據',
    "LIMIT_TRADE_BTC": "最少交易0.001BTC",
    "LIMIT_TRADE_C2C": "最少交易70元",
    "LIMIT_TRADE_ETH": "最少交易0.01ETH",
    "LIMIT_TRADE_USDT": "最少交易10USDT",
    "LIMIT_TRADE": "禁止小額訂單",
  },
  // 交易所
  exchange: {
    huobi: "火幣",
  },
  // 錢包
  wallet: {
    Rebind: "重新綁定",
    Account: '對方賬戶',
    BindAccount: "綁定賬戶",
    AccountType: "賬戶類型",
    "TransferHistory": "轉賬記錄",
    bind_text01: "未綁定賬戶，請綁定",
    "bind_success": "綁定成功",
    "TimeMachine": "時光機",
    "StarCraftCapsule": "星神艙",
    walletAccount: "我的錢包",
    tradeAccount: "交易賬戶",
    fiatAccount: "法幣賬戶",
    gameAccount: "遊戲賬戶",
    EstimatedBalance: "總資產折合:",
    myWallet: '我的錢包',
    toLogin: '登入操作錢包',
    noLogin: '你還沒有登入哦~',
    assetValuation: '資產估算',
    search: '輸入幣種名稱搜索',
    usable: '可用',
    action: "操作",
    available: "可用余額",
    freeze: "凍結金額",
    total: "總量",
    lock: '鎖定',
    trade: "交易",
    candy: "糖果",
    Referral: "推薦獎勵",
    give: "贈送",
    into: "轉入",
    wallet: "錢包",
    RollOut: "轉出",
    buy: "買入",
    sell: "賣出",
    deposit: '充值',
    MentionMoney: '提幣',
    withdraw: "提現",
    deal: '交易',
    transfer: '轉賬',
    hideBalance: "隱藏資金為0的幣種",
    depositAddress: "充值地址",
    minDeposit: "最小充值",
    address: "地址",
    amount: "數量",
    selectCategory: "選擇類別",
    selectCoin: "選擇幣種",
    startDate: "開始日期",
    to: "至",
    endDate: "結束日期",
    query: "查詢",
    category: "類別",
    otherAccount: "對方賬戶",
    submitSuccess: "提交成功",
    transferSuccess: "轉賬成功",
    Transfer: "劃轉",
    Transfers: "劃轉",
    TransferCoin: "劃轉幣種",
    TransferAmount: "劃轉數量",
    From: "從",
    To: "到",
    Maximum: "可劃轉余額:",
    TransferSuccess: "劃轉成功",
    Transfer_01: "超出可轉余額",
    Transfer_02: "不支持的劃轉方式",
    valuation: "估值",
    serviceFee: "服務費",
    chain_name: "鏈名稱",
  },
  // 交易
  buy: {
    price: '價格',
    amount: '數量',
    rental: '總額',
    availableBalance: '可用余額：',
    AllWarehouse: '全倉',
    AWarehouse: '半倉',
    warehouse: '倉',
    buy: '買入',
    sale: '賣出',
    TransactionsAreNotAllowedInThisCurrency: '該幣種不允許交易',
    sell: '賣',
    purchase: '買',
    type: '類型',
    turnover: '成交數量',
    hint: '提示',
    confirm: '確定',
    cancel: '取消',
    CommissionedByTheCurrent: '當前委托',
    BidHistory: '成交記錄'
  },
  // 登錄
  login: {
    welcomeLogin: '歡迎登錄',
    welcomeRegister: '歡迎註冊',
    noAccount: '還沒有賬戶？',
    isAccount: '已有賬戶?',
    register: '註冊',
    phoneOrEmail: "請輸入手機號或郵箱",
    code: "驗證碼",
    login: '登錄',
    loginIng: '正在登錄',
    registerIng: '正在註冊',
    submitIng: '正在提交',
    switchimg: "看不清？換一張",
    resend: "秒後可重發",
    allNationalities: "全部國籍",
    commonlyUsed: "常用",
    forgetPassword: '忘記密碼',
    cancel: '取消',
    confirm: '確定',
    password: '密碼',
    loginCuccess: '登錄成功',
    registerCuccess: '註冊成功',
    registerMobile: "手機註冊",
    registerEmail: "郵箱註冊",
    phoneNumber: "手機號",
    text_01: '使用手機號註冊',
    text_02: '使用郵箱註冊',
    text_03: '我已閱讀並同意服務條款',
    text_04: '服務條款',
    text_05: '隱私保護',
    text_06: '請閱讀並同意服務條款',
    text_07: '請輸入同時含有數字和字母，且長度在8-16位之間的密碼',
    text_08: '國籍信息註冊後不可修改，請務必如實選擇！',
    text_09: "郵箱",
    text_10: "參數不能為空",
    confirmPassword: '確認密碼',
    retrievePas: '找回密碼',
    phoneRetrieve: '手機找回',
    emailRetrieve: '郵箱找回',
    lastStep: '上一步',
    nextStep: '下一步',
    pasSetCuc: '密碼設置完成',
    error_500: '服務器開小差了，請稍後重試',
    verification: '驗證方式',
    default: '使用默認驗證方式',
    email: '郵箱驗證',
    phone: '手機驗證',
    google: '谷歌驗證',
    retpass: '正在找回密碼',
    inputcorrect: '請輸入正確的郵箱或手機號',
    inputnull: '請輸入郵箱或手機號',
    inputcode: '請輸入驗證碼',
    inputcodeerror: '驗證碼輸入錯誤',
    newpass: '新密碼',
    passnull: '密碼不能為空',
    chars: '請輸入密碼，8-20個非空白字符',
    surepass: '確認密碼',
    againpass: '請再次輸入密碼',
    nopass: '兩次輸入密碼不一致',
    forgots: '找回密碼',
    passwordResetS: "密碼重置成功",
    changepass: '密碼修改成功',
    perfect: '請完善信息',
    signs: '註冊新的會員賬戶',
    userName: '請輸入用戶名，3-20位字符',
    signaccount: '註冊賬戶',
    send: '發送',
    codenull: '請輸入驗證碼',
    setpass: '請設置登入密碼',
    referrer: '推薦碼',
    mustreferrer: '推薦碼（必填）'
  },
  // 找回密碼
  forgot: {
    retpass: '正在找回密碼',
    inputcorrect: '請輸入正確的郵箱或手機號',
    inputnull: '請輸入郵箱或手機號',
    inputcode: '請輸入驗證碼',
    newpass: '新密碼',
    passnull: '密碼不能為空',
    chars: '請輸入密碼，8-20個非空白字符',
    surepass: '確認密碼',
    againpass: '請再次輸入密碼',
    nopass: '兩次輸入密碼不一致',
    forgots: '找回密碼',
    changepass: '密碼修改成功',
    perfect: '請完善信息'
  },
  // 註冊
  sign: {
    userName: '請輸入用戶名，3-20位字符',
    usernameerror: "請輸入用戶名，3-20個非空白字符",
    chars: '請輸入密碼，8-20個非空白字符',
    inputnull: '請輸入郵箱或手機號',
    signs: '註冊新的會員賬戶',
    name: '請輸入用戶昵稱',
    signaccount: '註冊賬戶',
    send: '發送',
    codenull: '請輸入驗證碼',
    setpass: '請設置登入密碼',
    referrer: '推薦碼（非必填）',
    mustreferrer: '推薦碼（必填）',
    referrernull: "推薦碼不能為空",
    inputcorrect: '請輸入正確的郵箱或手機號',
    inputcode: '請輸入驗證碼',
    newpass: '新密碼',
    passnull: '密碼不能為空',
    surepass: '確認密碼',
    againpass: '請再次輸入密碼',
    nopass: '兩次輸入密碼不一致',
    forgots: '找回密碼',
    changepass: '密碼修改成功',
    inputcodeerror: '驗證碼輸入錯誤',
  },
  // c2c交易
  c2c: {
    "PLEASE_VERIFY_YOUR_REALNAME": "請先實名認證",
    deal: '交易',
    tradingRecord: '交易記錄',
    need: '需要',
    price: "價格",
    amount: "數量",
    time: "時間",
    action: "操作",
    type: "類型",
    orderID: "訂單號",
    ToBuyImmediately: '立即買入',
    acquirability: '可得',
    ImmediatelySell: '立即賣出',
    purchases: '買入量',
    BuyQuantity: '買入量',
    SellQuantity: '賣出量',
    TradeShow: '買賣說明',
    explain_1: '買賣商戶均為實地考察認證商戶，並提供100萬的USDT保證金，您每次兌換會凍結商戶資產，商戶資產不夠時，不能接單，可放心兌換',
    explain_2: '買賣商戶均為實名認證商戶，並提供保證金，可放心兌換',
    explain_3: '請使用本人綁定的銀行卡進行匯款，其他任何方式匯款都會退款。（禁止微信和支付寶）',
    explain_4: '商家處理時間9:00 - 21:00非處理時間的訂單會在第二天9:00開始處理，一般接單後24小時內會完成打款',
    explain_5: '單天最多只能發起5筆未處理充值訂單。',
    unitPrice: '單價',
    paymentInformation: '付款信息',
    orderInformation: "訂單信息",
    moneyOrder: '匯款訂單',
    ServiceProvider: "服務商信息",
    success: '成功',
    unfinished: "未完成",
    canceledCanc: '已取消',

    unconfirmed: "待確認",
    inhand: '處理中',
    haveExpired: '已過期',
    unpaid: '待支付',
    fBnak: "服務商開戶行",
    fNumber: "服務商賬號",
    name: '收款方戶名',
    oBnak: '收款方開戶行',
    number: '收款方賬號',
    txt: '匯款時備註內容',
    must: '(請務必填寫)',
    mobile: '收款方手機號碼',
    HaveTransfer: '已轉賬',
    cancel: '取消訂單',
    back: '返回',
    CancelWithdrawal: '取消提現',
    ToTransfer: '待轉賬',
    overdue: '過期',
    service: '服務商戶名',
    snum: '服務商手機號',
    tacount: '轉賬金額',
    state: "狀態",
    ordercancel: '訂單已取消',
    orderdispose: '訂單已提交處理',
    copysuccess: '復製成功',
    surecancel: '確定要取消嗎?',
    depositsuccess: '提現成功，請等待服務商處理',
    untreated: '未處理',
    text_01: "數量不能大於余額",
    text_02: "請按提示信息向該賣家匯款",
    text_03: "（禁止使用支付寶和微信）",
    remark: "轉賬備註",
    required: "必填",
    WaitingTransfer: "待轉賬",
    buy_text01: "買入數量必須是100的倍數",
  },
  otc: {
    AppealedOrders: "已申訴訂單",
    report: "我要申訴",
    openOtc: "開通OTC",
    otcRules: "申請開通OTC條件",
    buy: '買入',
    sell: '賣出',
    lastPrice: "實時價",
    high: "最高價",
    low: '最低價',
    merchant: "商家",
    merchantList: "商家列表",
    orderList: "訂單列表",
    tradePrice: "估價",
    buyByAmount: "按數量購買",
    buyByVol: "按金額購買",
    sellByAmount: "按數量出售",
    sellByVol: "按金額出售",
    buyPl: "請輸入購買總額",
    prompt_01: "必須本人賬戶支付",
    availableBalance: "可用余額",
    paymentMethod: "支付方式",
    PaymentCollection: "收款方式",
    bankTransfer: "銀行卡",
    alipay: "支付寶",
    weixin: "微信",
    tradeOrder: "普通交易",
    t_seller: "商家",
    limits: "限額",
    t_buy: "購買",
    t_sell: "出售",
    trade: "交易",
    minimumAmount: "單筆最小交易量",
    maxmumAmount: "單筆最大交易量",
    fee: "手續費",
    total: '總額',
    order_text01: "買家賬戶信息",
    order_text02: "請選擇以下方式給賣家付款",
    order_text03: "切勿備註「比特幣」,'虛擬幣'等信息請留意與對方實名是否一致",
    order_text04: "確認對訂單進行以下操作？",
    order_text05: "務必查看是否已收到相應款項",
    order_text06: "請確認已收到相應款項，操作後資金將直接打給對方，有不可追回風險，慎重操作！",
    order_text07: "請聯系客服獲取",
    true_name: "對方姓名",
    confirmationReceipt: "確認已收款",
    confirmPayment: "確認已付款",
    importantNote: "重要提示",
    paymentAmount: "付款金額",
    amountCollected: "收款金額",
    accountNumber: "賬號",
    realName: "實名",
    confirmCreate: "確認創建",
    failure: "失敗",
    partialSuccess: "部分成功",
    forThePayment: "待付款",
    paymentHasBeen: "已付款",
    forCollection: "待收款",
    waiting_process: "等待處理",
    confirmReceipt: "確認收款",
    dealOrders: "成交訂單",
    merchantOrder: "商家掛單",
    currentOrder: "當前掛單",
    completedOrder: "已完成訂單",
    cancelledOrder: "已取消訂單",
    buyer: "買家",
    seller: "賣家",
    moneyTotal: "金額",
    error_01: "不能大於數量",
    error_02: "最小交易量不能大於最大交易量",
    title_01: "請確認",
    text_04: "已實際訂單為準",
    text_05: "交易方式",
    text_06: "確認下單",
    text_07: "申請成為商家",
    text_08: "請選擇支付方式",
    text_09: "申請成為商家條件",
    text_10: "用戶賬號必須通過",
    text_11: "用戶賬號必須綁定",
    apply: "申請",
    allPay: "全部支付方式",
    pleaseEnter: "請輸入",

    "PLEASE_VERIFY_YOUR_REALNAME": "請先實名認證",
    deal: '交易',
    tradingRecord: '交易記錄',
    need: '需要',
    price: "價格",
    amount: "數量",
    time: "時間",
    action: "操作",
    type: "類型",
    orderID: "訂單號",
    ToBuyImmediately: '立即買入',
    acquirability: '可得',
    ImmediatelySell: '立即賣出',
    purchases: '買入量',
    BuyQuantity: '買入量',
    SellQuantity: '賣出量',
    TradeShow: '買賣說明',
    explain_1: '買賣商戶均為實地考察認證商戶，並提供100萬的USDT保證金，您每次兌換會凍結商戶資產，商戶資產不夠時，不能接單，可放心兌換',
    explain_2: '買賣商戶均為實名認證商戶，並提供保證金，可放心兌換',
    explain_3: '請使用本人綁定的銀行卡進行匯款，其他任何方式匯款都會退款。（禁止微信和支付寶）',
    explain_4: '商家處理時間9:00 - 21:00非處理時間的訂單會在第二天9:00開始處理，一般接單後24小時內會完成打款',
    explain_5: '單天最多只能發起5筆未處理充值訂單。',
    unitPrice: '單價',
    paymentInformation: '付款信息',
    orderInformation: "訂單信息",
    moneyOrder: '匯款訂單',
    ServiceProvider: "服務商信息",
    success: '成功',
    unfinished: "未完成",
    canceledCanc: '已取消',

    unconfirmed: "待確認",
    inhand: '處理中',
    haveExpired: '已過期',
    unpaid: '待支付',
    fBnak: "服務商開戶行",
    fNumber: "服務商賬號",
    name: '收款方戶名',
    oBnak: '收款方開戶行',
    number: '收款方賬號',
    txt: '匯款時備註內容',
    must: '(請務必填寫)',
    mobile: '收款方手機號碼',
    HaveTransfer: '已轉賬',
    cancel: '取消',
    back: '返回',
    CancelWithdrawal: '取消提現',
    ToTransfer: '待轉賬',
    overdue: '過期',
    service: '服務商戶名',
    snum: '服務商手機號',
    tacount: '轉賬金額',
    state: "狀態",
    ordercancel: '訂單已取消',
    orderdispose: '訂單已提交處理',
    copysuccess: '復製成功',
    surecancel: '確定要取消嗎?',
    depositsuccess: '提現成功，請等待服務商處理',
    untreated: '未處理',
    text_01: "數量不能大於余額",
    text_02: "請按提示信息向該賣家匯款",
    text_03: "（禁止使用支付寶和微信）",
    remark: "轉賬備註",
    required: "必填",
    WaitingTransfer: "待轉賬",
    buy_text01: "買入數量必須是100的倍數",
  },
  // 安全中心
  security: {
    LoginPasswordSetting: '登錄密碼設置',
    Certification: '實名認證',
    GoogleCertification: '谷歌認證',
    PaymentOfTheBinding: '支付綁定',
    verificationMode: '驗證方式',
    BindingMobilePhone: '綁定手機',
    change: "更換",
    bind: "綁定",
    text_01: "請輸入郵箱",
    text_02: "請輸入正確的郵箱",
    oldPassword: "舊密碼",
    newPassword: "新密碼",
    payPassword: "資金密碼",
    oldpayPassword: "舊資金密碼",
    newpayPassword: "新資金密碼",
    confirmPayPassword: "確認資金密碼",
    payPasswprd_01: "請輸入資金密碼",
    payPasswprd_02: '請輸入六位數純數字資金密碼',
    payPasswprd_03: '為了保證資金安全，請設置交易時輸入資金密碼',
    setSuccess: "設置成功",
    confirmPassword: "確認密碼",
    email: "郵箱",
    mobile: "手機號碼",
    password: "登錄密碼",
    email_text: "您綁定的郵箱為",
    mobile_text: "您綁定的手機號碼為",
    password_text: "登錄時使用",
    email_text_01: "您未綁定郵箱",
    mobile_text_01: "您未綁定手機號碼",
    gender: "性別",
    man: "男",
    woman: "女",
    secret: "保密",
    immediatelyChange: "立即修改",
    modifySuccess: "修改成功",
    avatar: "頭像",
    upload_text01: "上傳圖片只能是 JPG、JPEG、gif、bmp、PNG 格式!",
    username: "用戶名",
  },
  // 密碼驗證
  password: {
    changePassword: '密碼修改',
    PleaseEnterANewPassword: '請輸入新密碼',
    ConfirmNewPassword: '確認新密碼',
    resetPasswords: '重置密碼',
    passwordCannot: '密碼不能小於8位',
    DifferentPasswords: '密碼不相同',
    passwordEmpty: '密碼不能為空'
  },
  // 實名認證 
  certification: {
    id_card: "身份證",
    Certification: '實名認證',
    ordinaryCertification: "普通認證",
    identity: "身份認證",
    identityContent: "為了您的賬戶安全，請完善身份認證",
    senior: "高級認證",
    seniorContent: "為了您的賬戶安全，請完善高級認證",
    senior_1: "請先完成身份認證，再進行高級認證",
    attestation: "立即認證",
    certified: "已認證",
    Credentials: '填寫認證信息',
    results: "認證結果",
    inthereview: "審核中",
    hint: '上傳身份證正反面（請確保照片的內容完整並清晰可見，身份證必須在有效期內）。手持本人身份證正面照和個人簽字,個人簽字的內容包含',
    realNames: '真實姓名',
    validID: '身份證號碼',
    uploading: '上傳證件信息（請確保清晰可見）',
    frontCard: '身份證正面',
    versoCard: '身份證反面',
    handCard: '手持身份證',
    signature: '和當前日期（請確保照片和個人簽字的內容清晰可見）。',
    submit: '提交認證',
    AuditFailed: '審核未通過',
    cause: '原因:',
    revalidate: '重新驗證',
    audit: '實名審核中......',
    pass: '認證成功',
    frontCardFailToUpload: '身份證正面上傳失敗',
    versoCardFailToUpload: '身份證反面上傳失敗',
    handCardFailToUpload: '手持身份證上傳失敗',
    realName: '請輸入真實姓名',
    IDCard: '請輸入身份證號碼',
    await: '等待圖片上傳完成',
    submitSuccessfully: '提交成功',
    text_01: "恭喜你，完成了實名認證",
    text_02: "您的資料已提交審核，預計將在一個工作日內完成審核",
    text_03: "我們會保護您的個人信息安全,請您耐心等待！",
    text_04: "恭喜你，完成了高級認證",
    text_05: "信息不完整",
    IDType: "證件類型",
    step1: "上傳有效證件",
    step2: "等待審核",
    step3: "完成高級認證",
    pRequire: "照片要求:",

  },
  // 谷歌認證
  Google: {
    otp: "谷歌認證",
    certified: "已認證",
    unverified: "未認證",
    authentication: '認證',
    copy: '復製',
    gcode: '請輸入谷歌驗證碼',
    gopen: '開啟Google認證',
    turned: '您已開啟谷歌驗證',
    change: '更改',
    gvcode: '谷歌驗證碼',
    gcancel: '取消谷歌驗證',
    gnull: '谷歌驗證碼不能為空',
    pnull: '密碼不能為空',
    gerr: '谷歌驗證碼錯誤',
    perr: '密碼錯誤',
    bindSuccess: "綁定成功",
    unBindSuccess: "解綁成功",
    GoogleDownload: "下載谷歌驗證器",
    step1: "第一步",
    step2: "第二步",
    step3: "第三步",
    key: "密鑰:",
    text_01: "註意：此二維碼以及密鑰是獲取谷歌驗證碼唯一標識，請勿泄漏。",
    text_02: "使用谷歌驗證器掃描二維碼或輸入以下密鑰",
    text_03: "部分安卓手機不支持掃描二維碼,請選擇輸入密鑰方式",
    text_04: "填寫下方信息開啟谷歌認證",

  },
  // 支付綁定
  pay: {
    Payment: '支付綁定',
    bank: '開戶行名稱',
    bCard: '銀行卡卡號',
    change: '修改',
    confirm: '確定',
    addBank: "添加",
    delete: "刪除",
    default: "默認卡",
    setDefault: "設為默認",
    branch: "分支行",
    account: "賬號",
    weixin: "微信",
    alipay: "支付寶",
    bankCard: "銀行卡",
    text_01: "請先完成實名認證",
    text_02: "暫未綁定銀行卡",
    text_03: "確認刪除此卡？",
    text_04: "確定設置為默認卡？",
    text_05: "確認關閉？",
    text_06: "收款方式",

    goCertification: "去認證",


  },
  // 驗證方式
  vmode: {
    vmode: '驗證方式',
    Passauth: '密碼驗證',
    gauth: '谷歌驗證',
    eauth: '郵箱驗證',
    mauth: '短信驗證'
  },
  // 綁定手機
  bmobile: {
    bmobiles: '綁定手機',
    mnumber: '手機號碼',
    pnum: '請輸入手機號碼',
    mauth: '短信驗證碼',
    gcode: '獲取驗證碼',
    again: '秒後重新獲取',
    unbind: '解綁',
    submit: '提交',
    correctnum: '請輸入正確的手機號碼',
    unbindsuccess: '解綁成功',
    bindsuccess: '綁定成功'
  },
  // 搜索
  search: {
    antistop: '請輸入關鍵詞',
    search: '搜索'
  },
  // 關註貨幣
  currency: {
    attention: '已關註幣種',
    noattention: '未關註幣種',
    currencyname: '輸入幣種名稱實時過濾',
    acurrency: '關註幣種',
    kind: '種'
  },
  // 身份驗證
  showDialogs: {
    authentication: "身份驗證",
    password: '密碼',
    ppass: '請輸入密碼',
    gauth: '谷歌驗證碼',
    pgauth: '請輸入谷歌驗證碼',
    eauth: '郵箱驗證碼',
    peauth: '請輸入郵箱驗證碼',
    mauth: '手機驗證碼',
    pmauth: '請輸入手機驗證碼',
    code: "驗證碼",
    pcode: "請輸入驗證碼"
  },
  // 提幣
  withdrawto: {
    address: '地址名稱，如：我的地址1，選填',
    depositprice: '提現金額',
    inputprice: '請輸入金額',
    usableprice: '可用余額：',
    mindeposit: '最低提現：',
    fee: '傭金',
    available: "可用余額",
    withdraw: "提現",
    cancel: "取消",
    withdrawAddress: "提幣地址",
    withdrawAmount: "提現數量",
    text_01: "您尚未設置,點擊添加提幣地址",
    text_02: "提幣地址不能為空",
    text_03: "請選擇",
    text_04: "你確定刪除該地址嗎？",
    text_05: '鏈名稱不能為空',
    addAddress: "添加提幣地址",
    newAddress: "添加新地址",
    actual: "實際到賬",
    sure: '確定',
    cannotbezero: "數量不能為0",
    codenull: '請輸入驗證碼',
    minWithdrawal: "提現最低不能小於",
    deposit: '提幣',
    or: '或',
    taccounts: '轉帳',
    add: "添加新",
    edit: "修改",
    pinput: '請輸入',
    depositadd: '提現地址',
    AddressNote: "地址備註",
    code: "驗證碼",
    getCode: "獲取驗證碼",
    resend: "秒後可重發",
    raccount: '對方帳戶',
    prompt: "提示",
    deleteSuccess: "刪除成功",
    depositsuccess: '提現成功',
    addSuccess: "添加成功",
    editSuccess: "修改成功",
    addnull: '地址或提現金額不能為空',
    passerr: '密碼錯誤',
    gerr: '谷歌驗證碼錯誤'
  },
  // 充值
  payto: {
    qrcode: '充值到二維碼地址',
    copy: '復製',
    sweepcode: '掃一掃二維碼',
    getadd: '獲取充值地址',
    inputrecharge: '請輸入充值金額',
    sure: '確認',
    hint: '輸入要充值金額，過濾有充足資金的代理商（通過以下聯系方式聯系代理商幫你充值）',
    Rechargedefeated: '充值失敗',
  },
  // 充值提現記錄
  bill: {
    record: '充值提現記錄',
    allrecord: '全部記錄',
    rechargeRecord: '充值記錄',
    withdrawRecord: '提現記錄',
    ToAudit: '待審核',
    error: '錯誤',
    pulldown: '下劃查看更多',
    nodata: '沒有更多數據',
    loading: '加載中...'
  },
  // 鎖倉
  lock: {
    time: "時間",
    lockName: "鎖倉名稱",
    coin: "幣種",
    lockAmount: "鎖倉數量",
    lockValue: "鎖倉價值",
    status: "狀態",
    action: "操作",
    add: "添加",
    upgrade: "升級",
    selectLock: "選擇鎖倉",
    status_01: "進行中",
    status_02: "已完成",
    lock: "鎖倉",
    lockRules: "鎖倉規則"
  },
  game: {
    game: '遊戲',
    gameTips: '100%公平',
    available: "余額",
    rollDice: '投骰子',
    becomeDealer: '成為莊家',
    introduce: '玩法介紹',
    currentCoin: '當前幣種',
    bettingAmount: '投註金額',
    winningAmount: '贏取金額',
    winVictory: '獲勝',
    point: '點數',
    odds: '賠率',
    winningProbability: '中獎概率',
    user: '用戶',
    luckyNumber: '幸運數',
    reward: '獎勵',
    allBets: '所有投註',
    myBet: '我的投註',
    beADealer: '我要做莊',
    bonusPool: '獎金池',
    currentInvestment: '當前投資',
    bettingRatio: '投註占比',
    investedCoin: '投入幣種',
    investment: '投入',
    withdrawalCoin: '撤出幣種',
    step1: '1. 選擇需要投註貨幣',
    step2: '2. 設置需要投註量',
    step3: '3. 調整滑條上的滑塊位置，投註股子號碼範圍，改變勝出機率',
    step4: '4. 按下"投註"按鈕進行投註，如果搖到股子號碼在投註股子號碼範圍,立即中獎',
    moreThanBalance: '不能超出余額:',
    moreThanBets: '不能大於最大投註:',
    minimumbet: '不能小於最小投註:',
    win: '贏',
    lost: '輸',
    withdrawal: '撤出',
    investmentSuccess: '投資成功',
    divestmentSuccess: '撤資成功',
    bet: "投註",
    profit: "利潤",
    random: "換手氣",
    dealer: "做莊",
    rule: "規則",
    my: "我的",
    website: "網站",
    multiple: "倍數",
    scope: "範圍",
    AllBets: "所有投註",

    myBets: "我的投註",
    betInfo: "投註信息",
    serverSeed: "服務器種子",
    hash: "(散列)",
    customerSeed: "客戶種子",

    serialNumber: "流水號",
    change: "更換",
    changeSuccess: "更換成功",

    serverHash: "服務端種子哈希",
    randomNumber: "隨機數",
    rettingRecord: "投註記錄",

    NotReleased: "未公布",
    fair_01: "1. 此遊戲可由數學公式反向驗證出來每一個擲出的隨機點數都是公正的，營運方無法預先決定勝負結果。",
    fair_02: "2. 當你按下用戶菜單欄裏【換手氣】按鈕，系統將會產生一組服務器隨機種子的SHA256散列值，再配合客戶自行設定的 客戶隨機種子，及投註流水號， 我們將上述三個資料合並運算, 產生公正且隨機的投註結果。",

  },
  // 炒幣機器人
  financial: {
    old: "舊版",
    new: '新版',
    profitTop: "量化排行榜",
    dayStatistics: "日收益數據統計",
    returnsDetailed: "收益明細",
    coinTop: "收益幣種排行榜",
    bigData: "智能量化大數據",
    day: "今日",
    month: "本月",
    all: "所有",
    my: "我的",
    platform: "平臺",
    total: "總",
    pair: "交易對",
    uid: "用戶ID",
    available: "可用",
    freeze: "凍結",
    destroy: "銷毀",
    discuss: "交流",
    totalStatistics: "總量統計",
    fullscreen: "全屏模式",
    exitFullscreen: "退出全屏",
    quantize: "智能量化",
    dayProfit: "當日收益",
    totalRevenue: "累計收益",
    totalYield: "累計收益率",
    financial: "炒幣機器人",
    EquipmentBind: "設備綁定：",
    IsBinding: "已綁定",
    AddRobot: "添加機器人",
    help: "幫助",
    text_01: "請登陸APP進行綁定!",
    RobotList: "機器人列表",
    grossProfit: "總利潤：",
    IncomeRanked: "收益排行榜",
    market: "市場",
    buy: "已買入",
    revenue: "收益",
    Operations: "操作",
    grade: "等級",
    user: "用戶",
    bet: "投註",
    profit: "收益",
    delete: "刪除",
    add: "添加",
    robot: "機器人",
    edit: "修改",
    stop: "停止",
    start: "啟動",
    exchange: "交易所",
    robotHistory: "機器人歷史",
    robotResult: "機器人結果",
    setSuccess: "設置成功",
    exit: "是否退出",
  },
  // 推薦
  recommended: {
    title: "將推薦給您的朋友",
    history: "介紹的用戶以及獎勵",
    text_01: "對於每一個您推薦來的用戶，我們將獎勵您，具體獎勵見公告。",
    text_02: "我們將為您單獨生成一個鏈接，您可將此鏈接分享給您的朋友用以註冊。系統將標識使用此鏈接註冊的用戶是您所推薦的。",
    text_03: "不允許傳播任何誤導消息或作出任何有損",
    text_03_1: "品牌的行為。",
    text_04: "對於濫用此推薦獎勵機製的賬戶，我們將做凍結處理，且不會提前發出通知。",
    text_05: "您已閱讀並同意了我們的使用條款和先決條件",
    account: "賬戶",
    reward: "獎勵",
    addHistory: "添加記錄",
    bonusHistory: "獎勵記錄",
    referrerUid: "好友ID",
    status: "狀態",
    status_01: "已入帳",
    status_02: "未入帳",
  },
  // 幣種介紹
  introduces: {

    coinIntroduction: "幣種簡介",

    link: "鏈接",

    parameter: "技術參數",

    ChineseName: "中文名",

    EnglishName: "英文名",

    EnglishAbbreviation: "英文簡稱",

    Developer: "開發者",

    BlockTime: "區塊時間",

    DateIssue: "發布時間",

    CoreAlgorithm: "核心算法",

    MonetaryAggregates: "貨幣總量",
    whitePaper: "白皮書"
  },

  // 工單
  workOrder: {
    title: "問題標題",
    type: "類型",
    createTime: "創建時間",
    state: "狀態",
    operation: "操作",
    view: "查看",
    close: "關閉",
    create: "創建工單",
    content: "內容",
    text_01: "請具體並準確的描述您的問題,這有助於我們更高效的幫助您!",
    text_02: "只能上傳jpg/png/bmp/gif文件",
    text_03: "不能為空",
    upload: "上傳附件",
    pending: "待處理",
    processing: "處理中",
    complete: "處理完成",
  },
  "ACCOUNT_HAS_BEEN_DISABLED": "賬號被禁止",
  "DISABLE_LOGIN": "禁止登錄",
  "TOO_MANY_INCORRECT_LOGIN_PASSWORD": "登錄密碼錯誤次數太多，請十分鐘後再試",
  "GOOGLE_AUTHENTICATION_CODE_ERROR": "Google 驗證碼錯誤",
  "USER_DOES_NOT_EXIST": "用戶不存在",
  "ACCOUNT_OR_PASSWORD_IS_INCORRECT": "賬號或者密碼錯誤",
  "PLEASE_RE-VERIFY": "請重新驗證",
  "PLEASE_VERIFY_YOUR_REALNAME": "請先實名認證",
  "USER_NAME_TAKEN": "用戶名已被使用",
  "MOBILE_EXISTS": "手機號已存在",
  "EMAIL_EXISTS": "郵箱已存在",
  "CODE_HAS_SEND": "驗證碼已發送請註意查收",
  "THE_PASSWORD_MUST_NOT_BE_LESS_THAN_8_BITS": "密碼不能小於8位",
  "PARAMETER_ERROR": "不符合規範",
  "VERIFICATION_CODE_ERROR": "驗證碼錯誤",
  "INVALID_EMAIL": "無效的郵箱地址",
  "EMAIL_TAKEN": "郵箱已被使用",
  "MOBILE_TAKEN": "手機號已被使用",
  "INVALID_SMS_CODE": "驗證碼錯誤",
  "INVALID_NUMBER": "無效的手機號碼",
  "INVALID_CAPTCHA": "錯誤的驗證碼",
  "ACCOUNT_ERROR": "賬號錯誤",
  "BALANCE_NOT_ENOUGH": "余額不足",
  "SUCCESS": "成功",
  "PERMISSION_DENIED": "權限不足",
  "SEND_CODE_TOO_FAST": "發送驗證碼過快",
  "OPERATION_TOO_FAST": "操作過快",
  'PLEASE_LOGIN': '請登錄',
  "WRONG_PASSWORD": '密碼錯誤',
  "USERNAME_TAKEN": '用戶名已被使用'
}



// WEBPACK FOOTER //
// ./src/common/language/tw.js